import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SizeReferenceService extends BaseReferenceService {
  constructor() {
    super('SizeReference');
  }
}
